import { render } from "./EarLobeRepairContent.vue?vue&type=template&id=24444803&scoped=true"
import script from "./EarLobeRepairContent.vue?vue&type=script&lang=js"
export * from "./EarLobeRepairContent.vue?vue&type=script&lang=js"

import "./EarLobeRepairContent.vue?vue&type=style&index=0&id=24444803&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24444803"]])

export default __exports__